import {
  defaultTailorIndex,
  defaultTailorBind,
  defaultTailorBindDestroy,
  defaultTailors,
} from '@/services/RSMarket/defaultTailors';

export default {
  namespace: 'ValueAddedCenter_RSMarket_defaultTailors',

  state: {
    indexData: {
      list: [],
      pagination: {},
    },
    showData: {},
    tailors: [],
  },

  effects: {
    *index({ payload }, { call, put }) {
      const { status, data } = yield call(defaultTailorIndex, payload);

      if (status === 200) {
        yield put({
          type: 'saveIndexData',
          payload: {
            list: data.data,
            pagination: {
              total: data.total,
              pageSize: parseInt(data.per_page),
              current: parseInt(data.current_page),
            },
          },
        });
      }
    },

    *tailors({ payload }, { call, put }) {
      const { status, data } = yield call(defaultTailors, payload);

      if (status === 200) {
        yield put({
          type: 'saveTailorsData',
          payload: {
            data,
          },
        });
      }
    },

    *bind({ payload, callback }, { call, put }) {
      const { status } = yield call(defaultTailorBind, payload);

      if (status === 200) {
        if (callback) callback();
      }
    },

    *destroyBind({ payload, callback }, { call, put }) {
      const { status, data } = yield call(defaultTailorBindDestroy, payload);

      if (status === 204) {
        if (callback) callback();
      }
    },
  },

  reducers: {
    saveIndexData(state, action) {
      return {
        ...state,
        indexData: action.payload,
      };
    },
    saveShowData(state, action) {
      return {
        ...state,
        showData: action.payload,
      };
    },

    saveTailorsData(state, action) {
      return {
        ...state,
        tailors: action.payload.data,
      };
    },
  },
};
